module.exports = __webpack_public_path__ + "src/img/arrow.8e5ec3ef.svg";